import React, { useEffect, useState } from 'react';

import { PhoneFilled, WhatsAppOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import dayjs from 'dayjs';
import Modal from 'react-modal';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';

import {
  getFilteredNoti,
  ParseTransactionsCardList,
  parseTransactionsCardList,
} from './helpers';
import {
  IStationCardInnerContent,
  StationType,
} from './IStationCardInnerContent';
import StationQRCode from './StationQRCode';
import { customStyles, ModalButtonsWrapper, Wrapper } from './styles';

import { deleteChargePoint } from '../../../../hooks/chargepoints';
import { getChartsData } from '../../../../hooks/indicators';
import { getNotificationsByChargeBoxId } from '../../../../hooks/notifications';
import { getTransactions } from '../../../../hooks/transactions';
import { useTheme } from '../../../../hooks/useTheme';
import { addFilteredNotifications } from '../../../../redux/actions';
import { generateQRArtPNG } from '../../../../utils/generateQRArtPNG';
import { generateTerminalQRArtPNG } from '../../../../utils/generateTerminalQRArtPNG';
import { renderIconBadgeDataUri } from '../../../../utils/renderIconBadgeDataUri';
import { COLORS } from '../../../../utils/theme/colors';
import { themes } from '../../../../utils/theme/tenantColors';
import { BlackChart } from '../../../molecules/charts/BlackChart';
import {
  getColorByTitle,
  MOCK_1,
  parseChartData,
} from '../../../molecules/charts/tools';
import { expandCard } from '../../CardListConstructor/helpers';
import RealTimelineCardStyle from '../../RealTimelineCardStyle/RealTimelineCardStyle';
import StationTransactionsCardList from '../../StationTransactionsCardList/StationTransactionsCardList';

const START_DATE = dayjs().subtract(10, 'day').format('YYYY-MM-DD HH:mm:ss');
const END_DATE = dayjs().format('YYYY-MM-DD HH:mm:ss');

// Cor de marca do WhatsApp — fixa, não depende do tenant.
const WHATSAPP_GREEN = '#25D366';

const StationCardInnerContent = ({
  className,
  index,
  data,
  filteredNotifications,
  routes,
}: IStationCardInnerContent) => {
  const dispatch = useDispatch();
  const { theme } = useTheme();

  const user = JSON.parse(localStorage.getItem('auth-user'));

  const shouldShowTerminalQRCode = user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_TERMINAL_QRCODE' && !!permission.status,
  );

  const [stationSelected, setstationSelected] = useState<StationType | null>(
    null,
  );

  const [chartData, setchartData] = useState<any>(MOCK_1[2]); // ???
  const [isChartLoading, setisChartLoading] = useState(true);

  const [transactionsData, settransactionsData] =
    useState<ParseTransactionsCardList>();

  const [modalIsOpen, setIsOpen] = useState(false);

  const notifications = getFilteredNoti(
    filteredNotifications,
    stationSelected?.chargeBoxId,
  );

  useEffect(() => {
    setstationSelected(data[index]);
    settransactionsData([]);

    stationSelected &&
      getChartsData('28', String(data[index]?.about.chargerPk), '').then(
        (data) => {
          setchartData(parseChartData(data, '28')[2]);
          setisChartLoading(false);
        },
      );

    stationSelected &&
      getTransactions({
        chargeBoxPk: data[index]?.about.chargerPk,
        userOcppTag: '',
        fromDate: START_DATE,
        toDate: END_DATE,
        paymentStatus: '',
        searchInput: '',
        headerOrderList: null,
        page: null,
        size: null,
      }).then(({ list }) => {
        settransactionsData(parseTransactionsCardList(list));
      });

    stationSelected &&
      getNotificationsByChargeBoxId(data[index]?.chargeBoxId).then(
        (noti: any) => {
          dispatch(
            addFilteredNotifications(
              noti?.notificationList,
              data[index]?.chargeBoxId,
            ),
          );
        },
      );
  }, [stationSelected, index, data, dispatch]);

  const handleDownloadQRArt = async (
    e: React.MouseEvent,
    isTerminal = false,
  ) => {
    e.stopPropagation();

    const chargerPkText = String(stationSelected?.about.chargerPk).padStart(
      6,
      '0',
    );

    const qrValue = isTerminal
      ? `https://${localStorage.getItem(
          'terminalpayment-host',
        )}/?chargerBoxId=${stationSelected?.about.uuid}`
      : `https://${localStorage.getItem('deeplinking-host')}/station/${
          stationSelected?.about.chargerPk
        }/${stationSelected?.about.uuid}`;

    const currentTheme = theme || localStorage.getItem('theme');
    const tenantPrimaryColor = themes[currentTheme]?.primary ?? COLORS.primary;

    if (isTerminal) {
      await generateTerminalQRArtPNG({
        primaryColor: tenantPrimaryColor,
        qrValue,
        stationCode: chargerPkText,
        chargeBoxId: stationSelected?.chargeBoxId,
      });
      return;
    }

    const headerLogoEl = document.querySelector<HTMLImageElement>(
      `img.${currentTheme}-logo-header`,
    );
    const logoUrl =
      headerLogoEl?.src ??
      `https://storage.googleapis.com/mk-move-repository/white-label/${currentTheme}/images/dash-logo.png`;

    const [waIconDataUri, phoneIconDataUri] = await Promise.all([
      renderIconBadgeDataUri({
        icon: <WhatsAppOutlined />,
        backgroundColor: WHATSAPP_GREEN,
      }),
      renderIconBadgeDataUri({
        icon: <PhoneFilled />,
        backgroundColor: COLORS.secondary,
      }),
    ]);

    await generateQRArtPNG({
      primaryColor: tenantPrimaryColor,
      logoUrl,
      qrValue,
      stationCode: chargerPkText,
      chargeBoxId: stationSelected?.chargeBoxId,
      sacNumber: undefined,
      waIconDataUri,
      phoneIconDataUri,
    });
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleDelete = async (chargeBoxPk) => {
    const data = await deleteChargePoint(chargeBoxPk);

    if (data?.type === 'success') {
      message.success('Estação deletada com sucesso!');
      closeModal();
      setTimeout(() => {
        document.location.href = '/stations';
      }, 1000);
    } else {
      message.error('Não foi possível deletar a estação.');
    }
  };

  return (
    <Wrapper className={className}>
      <div className='section'>
        <div
          className='qrcode'
          onClick={(e) => {
            expandCard(e);
          }}
        >
          {stationSelected?.about.uuid && (
            <div className='qrcodes-wrapper'>
              <div className='qrcode-container'>
                <h4 className='strong label1'>Aplicativo</h4>
                <StationQRCode
                  containerId='qrcode-container'
                  chargerUuid={stationSelected.about.uuid}
                  chargerPk={stationSelected.about.chargerPk}
                  chargeBoxId={stationSelected?.chargeBoxId}
                />
                <button
                  className='button_station cursor'
                  onClick={(e) => {
                    message.info('Iniciando download...');
                    handleDownloadQRArt(e, false);
                  }}
                >
                  <p>{T('Baixar Arte do QR')}</p>
                </button>
              </div>

              {shouldShowTerminalQRCode && (
                <div className='qrcode-container-terminal'>
                  <h4 className='strong label1'>Terminal </h4>
                  <StationQRCode
                    containerId='qrcode-container-terminal'
                    chargerUuid={stationSelected.about.uuid}
                    chargerPk={stationSelected.about.chargerPk}
                    chargeBoxId={stationSelected?.chargeBoxId}
                    isTerminal
                  />
                  <button
                    className='button_station cursor'
                    onClick={(e) => {
                      message.info('Iniciando download...');
                      handleDownloadQRArt(e, true);
                    }}
                  >
                    <p>{T('Baixar Arte do QR')}</p>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className='station_details'>
          <p className='strong label1'>
            {stationSelected?.about.private ? 'Privada' : 'Pública'}
          </p>
          <p className='strong label2'>Grupo</p>
          <p className='strong label3'>Marca</p>
          <p className='strong label4'>Modelo</p>
          <p className='strong label5'>Versão de FM</p>
          <p className='value1'>
            {stationSelected?.about.group != 'Undefined'
              ? stationSelected?.about.group
              : T('Undefined')}
          </p>
          <p className='value2'>{stationSelected?.about.brand}</p>
          <p className='value3'>{stationSelected?.about.model}</p>
          <p className='value4'>
            {stationSelected?.about.fwVersion != 'Undefined'
              ? stationSelected?.about.fwVersion
              : T('Undefined')}
          </p>
        </div>
        {routes.find(({ path }) => path === '/stations/edit/:id') ? (
          <Link
            className='button_station cursor'
            to={`/stations/edit/${stationSelected?.about?.chargerPk}`}
          >
            <p>{T('Edit Chargebox')}</p>
          </Link>
        ) : null}
        {routes.find(({ path }) => path === '/stations/delete/:id') ? (
          <>
            <button
              className='button_station cursor delete_station'
              onClick={openModal}
            >
              <p>{T('Delete Chargebox')}</p>
            </button>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel='Example Modal'
            >
              <h1>
                {T('Delete Chargebox')} {stationSelected?.chargeBoxId}
              </h1>
              <p>
                {T(
                  'Are you sure you want to delete this station? When deleting, all the history already made in it will be lost.',
                )}
              </p>
              <ModalButtonsWrapper>
                <Button type='primary' onClick={closeModal}>
                  {T('Cancel')}
                </Button>
                <Button
                  type='primary'
                  danger
                  onClick={() =>
                    handleDelete(stationSelected?.about?.chargerPk)
                  }
                >
                  {T('Delete')}
                </Button>
              </ModalButtonsWrapper>
            </Modal>
          </>
        ) : null}
      </div>
      <RealTimelineCardStyle data={notifications} />
      <StationTransactionsCardList data={transactionsData} />
      <BlackChart
        color={getColorByTitle(chartData.key)}
        data={chartData?.series}
        loading={isChartLoading}
        className={'energy_chart'}
        title={chartData?.title}
        tooltip={chartData?.tooltip}
      />
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  filteredNotifications: state.notifications.filteredNotifications,
  routes: state.user.routes,
});

export default connect(mapStateToProps)(StationCardInnerContent);
